export interface IFormDataModel {
    name: string;
    value: string;
    checked: boolean;
    required?: boolean;
}

const fetchFormData = (e: any | HTMLFormElement) => {
    const formData =
        e instanceof HTMLFormElement ? (e as HTMLFormElement).elements : e.currentTarget.elements;
    return [...formData]
        .filter((element) => element.type !== 'submit')
        .map((element) => {
            if (element.type === 'radio') {
                return {
                    name: element.getAttribute('name'),
                    value: element.value,
                    checked: element.checked,
                } as IFormDataModel;
            }

            return {
                name: element.getAttribute('name'),
                value: element.type === 'checkbox' ? element.checked : element.value,
                required: element.getAttribute('data-set-required'),
            } as IFormDataModel;
        });
};

export default fetchFormData;
